var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riskWarn',{attrs:{"domain":"payroll","pageTitle":"欠薪预警","themeColor":"#FF5FA2","subTabs":['欠薪'],"showAmount":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }